import styled from 'styled-components'
import { Input } from 'antd'

const { Search } = Input

/***
 * 备注：dark前加$是为了修复 Received 'false' for a non-boolean attribute 的 问题
 * https://stackoverflow.com/questions/49784294/warning-received-false-for-a-non-boolean-attribute-how-do-i-pass-a-boolean-f
 */

export const MySearch = styled(Search)<{ $dark?: boolean; width?: number }>`
  border: 2px solid
    ${props => (props.$dark ? props.theme.dark3 : props.theme.light1)};
  color: ${props => props.theme.dark4};
  border-radius: 8px;
  padding: 2px 3px;
  width: ${props => props.width || '192'}px;
  background: none;
  &:focus {
    border-color: ${props => props.theme.primaryColor};
  }
  .ant-input-affix-wrapper {
    background: ${props => (props.$dark ? 'transparent' : '#fff')};
    border: none;
    padding: 5px 11px;
    &.ant-input-affix-wrapper-focused {
      box-shadow: none;
    }
  }
  .ant-input {
    background: ${props => (props.$dark ? 'transparent' : '#fff')};
    color: ${props => (props.$dark ? props.theme.light2 : props.theme.dark2)};
    &::placeholder {
      font-size: 12px;
      color: ${props => (props.$dark ? props.theme.dark4 : props.theme.dark5)};
    }
  }
  > .ant-input-group > .ant-input-group-addon:last-child {
    background: ${props => (props.$dark ? 'transparent' : '#fff')};
    .ant-input-search-button:not(.ant-btn-primary) {
      background: ${props => (props.$dark ? 'transparent' : '#fff')};
      border: none;
      color: ${props => props.theme.dark4};
      transition: all 0.3s ease;
      &:hover {
        transition: all 0.3s ease;
        color: ${props =>
          props.$dark ? props.theme.light2 : props.theme.dark2};
      }
    }
  }
  .anticon-close-circle {
    color: ${props => (props.$dark ? props.theme.dark4 : props.theme.dark2)};
  }
  .anticon-search {
    font-size: 20px;
  }
`
